<template>
  <div class="flex justify-center">
    <div style="width: 22rem">
      <div class="flex flex-col items-center">
        <h1 class="text-4xl text-chblue">Ceník</h1>
        <p class="pb-4 text-xl text-gray-700">2025</p>
        <div class="flex border border-gray-400 rounded-full">
          <p
            @click.prevent="mainSeason = true"
            class="flex items-center px-4 mr-2 text-sm text-white rounded-full cursor-pointer md:text-base"
            :class="{
              'bg-ch-800': mainSeason,
              'text-white': mainSeason,
              'text-gray-800': !mainSeason,
            }"
          >
            Hlavní sezona
          </p>
          <p
            @click.prevent="mainSeason = false"
            class="flex items-center px-4 py-1 text-sm rounded-full cursor-pointer md:text-base"
            :class="{
              'bg-ch-800': !mainSeason,
              'text-white': !mainSeason,
              'text-gray-800': mainSeason,
            }"
          >
            Mimo sezonu
          </p>
        </div>
      </div>

      <div class="flex flex-col items-center h-56 pt-6 text-lg">
        <transition name="slide-fade" mode="out-in">
          <div v-if="mainSeason" key="mainSeason">
            <p class="text-xl text-center text-gray-700">
              28. 6. - 31. 8. 2025
            </p>
            <div>
              <div class="flex items-center justify-center pt-4">
                <p class="text-2xl font-medium text-center text-gray-900">
                  2 750Kč /den
                </p>
                <p class="ml-2 text-gray-800">(max. 5 osob)</p>
              </div>
              <p class="pt-4 text-base text-chsoftblue">
                Po dohodě každá další osoba 450 Kč/den.
              </p>
              <p class="pt-2 text-base text-chsoftblue">
                Děti nemají nárok na slevu.
              </p>
              <p class="pt-2 text-base text-chsoftblue">
                V případě větší spotřeby elektřiny a dřeva bude požadován
                příplatek.
              </p>
            </div>
          </div>
          <div v-else key="offseason">
            <p class="text-xl text-center text-gray-800">1. 3. - 27. 6. 2025</p>
            <p class="text-xl text-center text-gray-800">
              1. 9. - 30. 11. 2025
            </p>
            <div>
              <p class="pt-4 text-2xl font-medium text-center text-gray-900">
                550 Kč / osobu /den
              </p>
              <p class="pt-2 text-base text-center text-chsoftblue">
                Při obsazenosti 2 a méně osob 600Kč.
              </p>
              <p class="pt-4 text-base text-center text-chsoftblue">
                Topení (elektřina a dřevo) se doplácí dodatečně.
              </p>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mainSeason: true,
    };
  },
};
</script>

<style>
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter {
  transform: translateX(40px);
  opacity: 0;
}

.slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(-40px);
  opacity: 0;
}
</style>
